import { createStore } from 'vuex'
import { auth } from './auth.module'
import { Modals } from './modals'

export default createStore({
  state: {
    // Sidebar
    sidebarVisible: '',
    sidebarUnfoldable: true,
    // Global Loading
    loading: false,
    // Year Program
    yearProgram: '2022',
    // RRA PRA Steps
    rraPraStep: 1,
    // Modals
    showModals: { ...Modals.showModals }
  },
  mutations: {
    loadingOn(state) {
      state.loading = true
    },
    loadingOff(state) {
      state.loading = false
    },
    toggleSidebar(state) {
      if (state.sidebarVisible == false) {
        state.sidebarVisible = !state.sidebarVisible
      } else {
        state.sidebarUnfoldable = !state.sidebarUnfoldable
      }
    },
    toggleUnfoldable(state) {
      state.sidebarUnfoldable = !state.sidebarUnfoldable
    },
    updateSidebarVisible(state, payload) {
      state.sidebarVisible = payload.value
    },
  },
  actions: {},
  modules: {
    auth
  },
})
